import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_grids2d_set_current_cell_neigbours = (payload: DTO__grid2d_cell[][]): PayloadAction<DTO__grid2d_cell[][]> => ({
  type: ENUM__redux_action.UI__GRID2D__SET_CURRENT_CELL_NEIGBOURS,
  payload,
});

export function INIT_LOCAL__ui_grids2d_set_current_cell_neigbours(state: STATE__ui, action: PayloadAction<DTO__grid2d_cell[][]>) {
  let cells_rows = [];

  for (let cells_row of action.payload) {
    let cells = cells_row.map(cell => cell.clone());
    cells_rows.push(cells);
  }

  state.global__grid2d_gallery_cell_neigbours = cells_rows;
}
